import Phaser from 'phaser'
import {
    CST
} from '../CST'

var clickSound;

export default class MenuScene extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.MENU)
    }

    preload() {}

    create() {
        clickSound = this.sound.add("clickSound");

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'start_background');

        const play = this.add.image(this.cameras.main.width / 2 - 250, (this.cameras.main.height / 2) + 350, 'btn_play');
        play.setInteractive({
            useHandCursor: true
        });
        play.on("pointerdown", () => {
            clickSound.play();
            this.scene.stop();
            this.scene.start(CST.SCENES.TEAMS);
        })

        const rules = this.add.image(this.cameras.main.width / 2 + 250, (this.cameras.main.height / 2) + 350, 'btn_rules');
        rules.setInteractive({
            useHandCursor: true
        });
        rules.on("pointerdown", () => {
            clickSound.play();
            this.scene.pause();
            this.scene.launch(CST.SCENES.RULES1, {
                scene: CST.SCENES.MENU
            });
        })
    }
}